/**
 * Figma 542:4327 / 675:40544 — callout tooltip above the Usage help icon
 * (`side=top`, `align=end`, arrow bottom-right, 12px gap to the trigger). DS
 * `TooltipContent` supplies
 * `bg-callout-background`, `text-text-primary-on-dark`, `shadow-md`, and arrow
 * fill; only Caption typography differs from the default `text-sm`.
 */
export const creditUsageCoverageTooltipContentClasses =
  'max-w-[280px] p-3 ps-4 text-xs font-normal leading-snug';
